export default {
  namespaced: true,
  state() {
    return {
      sponsoredItemTop: {
        product: null,
        sponsoredData: {},
      },
    };
  },
  getters: {
    getSponsoredItemTop: (state) => state.sponsoredItemTop.product,
    getSponsoredItemTopRef: (state) => state.sponsoredItemTop.sponsoredItemTopRef,
  },
  mutations: {
    setSponsoredItemTop(state, product) {
      state.sponsoredItemTop.product = product;
    },
    setSponsoredItemTopRef(state, sponsoredItemTopRef) {
      state.sponsoredItemTop.sponsoredItemTopRef = sponsoredItemTopRef;
    },
  },
  actions: {
    setSponsoredItemTop({ commit }, product) {
      commit('setSponsoredItemTop', product);
    },
    setSponsoredItemTopRef({ commit }, sponsoredItemTopRef) {
      commit('setSponsoredItemTopRef', sponsoredItemTopRef);
    },
  },
};
